import { api } from '../api';

export const EventApi = {
	GetEventStatus: (event_se) => api.get(`api/event/status?event_se=${event_se}`),
	GetEventDetail: (event_se) => api.get(`api/events?event_se=${event_se}`),
	getContent: (event_se, page, size) =>
		api.get(
			`api/event/content?event_se=${event_se}&page=${page}&size=${size}&`
		),
	postContent: (data) => api.post(`api/event/content`, data),
};
